import apiClient from './apiClient';

/**
 * Public service for handling anonymous requests like consultations and contact forms.
 */
const publicService = {
    /**
     * Submit a free consultation request
     * POST /public/free-consultation
     */
    submitFreeConsultation: async (data) => {
        try {
            const response = await apiClient.post('/public/free-consultation', data);
            return response.data;
        } catch (error) {
            console.error('[PublicService] Error submitting free consultation:', error);
            throw error;
        }
    },

    /**
     * Submit a contact request
     * POST /public/contact-request
     */
    submitContactRequest: async (data) => {
        try {
            const response = await apiClient.post('/public/contact-request', data);
            return response.data;
        } catch (error) {
            console.error('[PublicService] Error submitting contact request:', error);
            throw error;
        }
    }
};

export default publicService;
